export default __webpack_public_path__ + "static/biztositek-a4cd693a51a53a6c4ab4b466d1123fa3.jpg";